import { render, staticRenderFns } from "./i-td.vue?vue&type=template&id=42af65fa&scoped=true&"
import script from "./i-td.vue?vue&type=script&lang=js&"
export * from "./i-td.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42af65fa",
  null
  
)

export default component.exports